export default __webpack_public_path__ + "static/media/yodle.03d36821.mp3";